<template>
  <v-layout justify="center">
    <v-dialog v-model="dialog" width="90%">
      <v-card>
        <v-card-title>
          <v-layout align-center justify-center row class="pt-3">
            <span
              :style="{
                fontSize: '20px',
                fontWeight: '500',
                letterSpacing: '.02em',
                whiteSpace: 'nowrap',
              }"
            >
              Encuesta para módulo de pagos
            </span>
            <v-btn
              :style="{ position: 'absolute', right: 0, top: 0 }"
              icon
              @click="dialog = false"
            >
              <v-icon>close</v-icon>
            </v-btn>
          </v-layout>
        </v-card-title>
        <v-card-text>
          <div
            class="pa-4"
            :style="{
              border: '2px solid',
              borderRadius: '15px',
              height: '50vh',
              overflowY: 'scroll',
            }"
          >
            <div v-for="(question, i) in poll.questions" :key="i">
              <span
                class="text-red"
                v-html="
                  `${i + 1}.- ${question.text.replace(/\[[^\]]*\]/g, m => {
                    let [name, ...rest] = m.replace(/\[|\]/g, '').split(':');
                    return `<span><a style='color:blue' href='${rest.join(
                      ':'
                    )}' target='_blank'>${name}</a></span>`;
                  })}
                `
                "
              />
              <div v-show="question.type == 'TEXT'" style="margin-bottom: 2%;">
                <v-layout wrap row class="questions-size">
                  <v-flex xs12 md12 lg12 px-5>
                    <v-textarea
                      auto-grow
                      rows="1"
                      data-min-rows="1"
                      v-model="question.value"
                      placeholder="Escribe una respuesta"
                      required
                      maxlength="220"
                    />
                  </v-flex>
                </v-layout>
              </div>
              <div v-show="question.type == 'SINGLE'">
                <v-layout wrap row class="questions-size">
                  <v-flex xs12 md12 lg12 px-5>
                    <v-radio-group v-model="question.value">
                      <v-radio
                        color="#eb5860"
                        v-for="(answer, j) in question.answers"
                        :key="j"
                        :value="answer.text"
                      >
                        <template v-slot:label>
                          {{ answer.text }}
                        </template>
                      </v-radio>
                    </v-radio-group>
                  </v-flex>
                </v-layout>
              </div>
              <div v-show="question.type == 'SINGLE_COMPLETE'">
                <v-layout wrap row class="questions-size">
                  <v-flex xs12 md12 lg12 px-5>
                    <v-radio-group v-model="question.value">
                      <v-radio
                        color="#eb5860"
                        v-for="(answer, j) in question.answers"
                        :key="j"
                        :value="answer.text"
                      >
                        <template v-slot:label>
                          <span>{{ answer.text.split("{empty}")[0] }}</span>
                          <span
                            v-show="answer.text.includes('{empty}')"
                            class="px-1"
                          >
                            <input
                              v-model="question.valueComplete"
                              :style="{
                                border: '1px solid',
                                borderRadius: '5px',
                                width: '300px',
                                padding: '3px',
                              }"
                            >
                          </span>
                          <span>{{ answer.text.split("{empty}")[1] }}</span>
                        </template>
                      </v-radio>
                    </v-radio-group>
                  </v-flex>
                </v-layout>
              </div>
              <div v-show="question.type == 'MULTIPLE'" class="pb-3">
                <div
                  v-for="answer in question.answers"
                  :key="`${question.text}-${answer.text}`"
                >
                  <v-layout wrap row>
                    <v-flex xs12 md12 lg12 px-5 style="padding-top: 10px;">
                      <label>
                        <input
                          type="checkbox"
                          v-model="answer.value"
                          @click="
                            event =>
                              toggleAll(
                                i,
                                event,
                                answer.text == 'Todos los anteriores'
                              )
                          "
                        >
                        <span
                          class="check-box-effect"
                          style="margin-top: 10px;"
                        />
                        <label style="padding-left: 10px;">{{
                          answer.text
                        }}</label>
                      </label>
                    </v-flex>
                  </v-layout>
                </div>
              </div>
              <div v-show="question.type == 'COMPLETE'" class="pb-3">
                <div
                  v-for="answer in question.answers"
                  :key="`${question.text}-${answer.text}`"
                >
                  <v-layout
                    row
                    px-5
                    align-end
                    justify-start
                    style="padding-top: 20px;"
                  >
                    <v-flex shrink>
                      <label>
                        {{ answer.text.split("{empty}")[0] }}
                      </label>
                    </v-flex>
                    <v-flex
                      shrink
                      v-show="answer.text.includes('{empty}')"
                      class="px-1"
                    >
                      <input
                        :style="{
                          border: '1px solid',
                          borderRadius: '5px',
                          width: '100px',
                          padding: '3px',
                        }"
                        v-model="answer.value"
                      >
                    </v-flex>
                    <v-flex shrink>
                      <label>
                        {{ answer.text.split("{empty}")[1] }}
                      </label>
                    </v-flex>
                  </v-layout>
                </div>
              </div>
            </div>
          </div>
        </v-card-text>
        <div>
          <div class="px-3">
            <span class="text-red">
              *Es necesario reponder todas las preguntas
            </span>
          </div>
          <v-layout align-center justify-center row class="pb-3">
            <v-btn dark round color="gradiente" text @click="dialog = false">
              Contestar después
            </v-btn>
            <v-btn dark round color="gradiente" text @click="submit">
              Enviar
            </v-btn>
          </v-layout>
        </div>
      </v-card>
    </v-dialog>
    <div data-app>
      <alerta
        v-model="modals.alert"
        :text="modals.Clave"
        :title="modals.Title"
        :cond="modals.Cond"
        @cancelled="onCancel"
      />
    </div>
  </v-layout>
</template>

<script>
import { mapGetters } from "vuex";
import alerta from "../Routes/PollAlert.vue";

export default {
  components: {
    alerta,
  },
  data() {
    return {
      dialog: false,
      identifier: null,
      success: false,
      poll: {
        questions: [],
      },
      modals: {
        alert: false,
        Clave: "",
        Title: "",
        Cond: false,
      },
    };
  },
  methods: {
    toggleAll(index, e, enable) {
      if (enable == false) {
        return;
      }
      const val = e.target.checked;
      const mutateSt = { ...this.poll };
      mutateSt.questions[index].answers.forEach(a => {
        a.value = val;
      });
      this.poll = mutateSt;
    },
    submit() {
      const questions = this.poll.questions.map(question => {
        const answered = { ...question };
        if (question.type == "MULTIPLE") {
          answered.answers = question.answers
            .filter(q => q.value)
            .map(q => ({ text: q.text, index: q.index }));
        } else if (question.type == "COMPLETE") {
          answered.answers = question.answers
            .filter(q => !!q.value)
            .map(q => ({
              text: q.text.replace(/{empty}/g, q.value),
              index:q.index
            }));
        } else if (question.type == "SINGLE") {    
          if(answered.value){
            const index = answered.answers.find(a=> a.text === answered.value).index
            answered.answers =  [{ text: answered.value, index }]
          } else {
            answered.answers =  [];
          }
          delete answered.value;
        } else if (question.type == "SINGLE_COMPLETE") {
          if( answered.value){
            const index = answered.answers.find(a=> a.text === answered.value).index
            answered.answers = [
                {
                  text: answered.value.replace(
                    /{empty}/g,
                    answered.valueComplete || '{empty}'
                  ),
                  index,
                },
              ]
          } else {
            answered.answers = []
          }
          delete answered.value;
          delete answered.valueComplete
        } else if (question.type == "TEXT") {
          answered.answers = answered.value ? [{ text: answered.value }] : [];
        }
        return answered;
      });

      this.$store
        .dispatch("globalPolls/answerPoll", {
          identifier: this.identifier,
          poll: {
            ...this.poll,
            questions,
          },
        })
        .then(() => {
          this.modals.Title = "¡Encuesta realizada con éxito!";
          this.modals.Clave = "Tus respuestas han sido enviadas con éxito.";
          this.modals.Cond = true;
          this.modals.alert = true;
          this.success = true;
        })
        .catch(() => {
          this.modals.Title = "Problema al enviar respuestas";
          this.modals.Clave =
            "Asegurate de haber contestado todas las preguntas ";
          this.modals.Cond = true;
          this.modals.alert = true;
          this.success = false;
        });
    },
    onCancel() {
      this.modals.alert = false;
      if (this.success) {
        this.dialog = false;
      }
      this.$forceUpdate();
    },
  },
  watch: {
    pendingPolls() {
      if (this.pendingPolls.length) {
        let firstPoll = this.pendingPolls[0];
        this.$store
          .dispatch("globalPolls/retrieveGlobalPoll", firstPoll.identifier)
          .then(res => {
            this.dialog = true;
            this.identifier = firstPoll.identifier;
            this.poll = res.data;
          });
      }
    },
  },
  computed: {
    ...mapGetters("globalPolls", {
      pendingPolls: "pendingPolls",
    }),
  },
};
</script>

<style scoped>
.text-red {
  color: red;
}
</style>
